import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaPlus, FaTrash, FaEdit, FaStar, FaSave, FaTimes } from "react-icons/fa";

export default function AdminPackages({ lang, admin_id }) {
  const [packages, setPackages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    id: null, name_ar: '', name_en: '', desc_ar: '', desc_en: '', price: 0, max_projects: '1', is_popular: 0
  });

  const fetchPackages = async () => {
    try {
      const url = window.location.hostname === 'localhost' ? 'http://localhost/api/manage_packages.php' : '/api/manage_packages.php';
      const res = await axios.get(url);
      if (res.data.status === 'success') {
        setPackages(res.data.packages);
      }
    } catch (err) { console.error(err); }
  };

  useEffect(() => { fetchPackages(); }, []);

  const openAdd = () => {
    setEditMode(false);
    setFormData({ id: null, name_ar: '', name_en: '', desc_ar: '', desc_en: '', price: 0, max_projects: '1', is_popular: 0 });
    setShowModal(true);
  };

  const openEdit = (pkg) => {
    setEditMode(true);
    setFormData({ ...pkg });
    setShowModal(true);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const url = window.location.hostname === 'localhost' ? 'http://localhost/api/manage_packages.php' : '/api/manage_packages.php';
      const method = editMode ? 'put' : 'post';
      const payload = { ...formData, admin_id, package_id: formData.id };
      
      const res = await axios({ method, url, data: payload });
      if (res.data.status === 'success') {
        alert("تم الحفظ بنجاح");
        setShowModal(false);
        fetchPackages();
      } else { alert(res.data.message); }
    } catch (err) { alert("حدث خطأ"); }
  };

  const handleSetPopular = async (id) => {
    try {
      const url = window.location.hostname === 'localhost' ? 'http://localhost/api/manage_packages.php' : '/api/manage_packages.php';
      await axios.put(url, { admin_id, package_id: id, action: 'set_popular' });
      fetchPackages();
    } catch (err) { alert("حدث خطأ"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("هل أنت متأكد من الحذف؟")) return;
    try {
      const url = window.location.hostname === 'localhost' ? 'http://localhost/api/manage_packages.php' : '/api/manage_packages.php';
      await axios.delete(url, { data: { admin_id, package_id: id } });
      fetchPackages();
    } catch (err) { alert("حدث خطأ"); }
  };

  return (
    <div className="table-container">
      <div className="section-header">
        <h4>📦 إدارة الباقات الديناميكية</h4>
        <button className="btn-primary" onClick={openAdd}><FaPlus /> إضافة باقة</button>
      </div>
      
      <div className="table-responsive">
        <table className="data-table">
          <thead>
            <tr>
              <th>الاسم (عربي)</th>
              <th>السعر</th>
              <th>الأكثر رواجاً</th>
              <th>إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {packages.map(pkg => (
              <tr key={pkg.id}>
                <td>{pkg.name_ar}</td>
                <td>{pkg.price} EGP</td>
                <td>
                  <button className="icon-btn" style={{ color: pkg.is_popular == 1 ? '#f59e0b' : '#ccc' }} onClick={() => handleSetPopular(pkg.id)}>
                    <FaStar />
                  </button>
                </td>
                <td>
                  <button className="icon-btn" onClick={() => openEdit(pkg)} style={{ color: '#0E74AB', marginRight: '10px' }}><FaEdit /></button>
                  <button className="icon-btn" onClick={() => handleDelete(pkg.id)} style={{ color: '#F44336' }}><FaTrash /></button>
                </td>
              </tr>
            ))}
            {packages.length === 0 && <tr><td colSpan="4">لا توجد باقات حالياً. استخدم الزر لاضافة باقات.</td></tr>}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-container" style={{maxWidth: '600px'}}>
            <button className="modal-close" onClick={() => setShowModal(false)}><FaTimes /></button>
            <h3>{editMode ? "تعديل باقة" : "إضافة باقة"}</h3>
            <form onSubmit={handleSave} style={{display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '15px'}}>
              <input type="text" placeholder="الاسم (عربي)" value={formData.name_ar} onChange={e => setFormData({...formData, name_ar: e.target.value})} required className="modal-input" />
              <input type="text" placeholder="الاسم (إنجليزي)" value={formData.name_en} onChange={e => setFormData({...formData, name_en: e.target.value})} required className="modal-input" />
              <textarea placeholder="الوصف (عربي)" value={formData.desc_ar} onChange={e => setFormData({...formData, desc_ar: e.target.value})} className="modal-textarea" />
              <textarea placeholder="الوصف (إنجليزي)" value={formData.desc_en} onChange={e => setFormData({...formData, desc_en: e.target.value})} className="modal-textarea" />
              <input type="number" placeholder="السعر" value={formData.price} onChange={e => setFormData({...formData, price: e.target.value})} required className="modal-input" />
              <input type="text" placeholder="أقصى عدد للبروجكتات" value={formData.max_projects} onChange={e => setFormData({...formData, max_projects: e.target.value})} className="modal-input" />
              <button type="submit" className="btn-primary"><FaSave /> حفظ</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
